export { mapArrayOfMapsTo2dArray } from './mapArrayOfMapsTo2dArray';
